export default __webpack_public_path__ + "static/media/marker-bad.923e8566.svg";